import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import EmptyTask from '../assets/empty-task.gif';
import Loading from '../general/Loading';

const AdminDashboard = () => {
        const [responseMessage, setResponseMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
    const [myPackage, setMyPackage] = useState([]);
    const [expand, setExpand] = useState({});
    const [showDelete, setShowDelete] = useState(false);
    const [selectedPkg, setSelectedPkg] = useState('');

      useEffect(() => {
        const fetchPackage = async () => {
          try {
            const response = await fetch('https://api.shaktitours.com/get-package');
            const data = await response.json();
    
            if (response.ok) {
              setMyPackage(data);
            } else {
              console.error('Failed to fetch enquiries:', data);
            }
          } catch (error) {
            console.error('Error while fetching enquiries:', error);
          }
        };
    
        fetchPackage();
      }, []); 
    

const toggleSection = (pkgId, section) => {
  setExpand((prev) => ({
    ...prev,
    [pkgId]: {
      sightseeing: false,
      meal: false,
      accomodation: false,
      [section]: !prev[pkgId]?.[section],
    },
  }));
};

const handleShowRemove = (pkg) => {
  setSelectedPkg(pkg);
  setShowDelete(true);
}

  const handleDelete = async (pkgId) => {
    setLoading(true);

    try {
      const response = await fetch(`https://api.shaktitours.com/delete-package/${pkgId}`, {
        method: "DELETE"
      });

      setLoading(false);
      setMyPackage(prevPkg => prevPkg.filter(p => p.id !== pkgId));
      setResponseMessage("Package Removed Successfully");
      setShowDelete(false);
      setTimeout(() => {
        setResponseMessage('');
        // window.location.reload();
      }, 2000);
    } catch (error) {
      setLoading(false);
      console.log(error.message);
    }
  }


  return (
    <>
                    <section className='banner2-bg'>
                <div className='container text-center'>
                    <p className='subheader-text'>Admin Dashboard</p>
                </div>
            </section>

          <section className='my-5'>
        <div className='container'>

<button className='nav-btn bg-black' onClick={() => navigate('/add-package')}><i class="fa-solid fa-plus"></i> Add New Package</button>

<div className='row mt-4'>

                      {myPackage.length > 0 ? (
                myPackage.map((pkg, index) => (
<div className='col-lg-6 col-12 my-2'>
<div className='package-outer'>
<span className='package-span'>{pkg.day} Days {pkg.night} Night</span>

<img src={`https://api.shaktitours.com/uploads/${pkg.image}`} className='img-fluid' />
<div className='px-3 py-3'>
<p className='fs-5 fw-semibold fm-dm my-0'>{pkg.pac_name}</p>
<p className='package-point mt-2'><span>Start Point<br/>{pkg.start_point}</span>
<i class="fa-solid fa-arrow-right-arrow-left fs-3 py-2 text-dark"></i><span className='text-end'>End Point<br/>{pkg.dest_point}</span></p>

<p className='text-success fw-bold'>₹{pkg.price}/person</p>

<div className='d-flex justify-content-between text-center'>
<p onClick={() => toggleSection(pkg.id, 'sightseeing')}><i class="fa-solid package-icon fa-face-smile"></i><br /><span className='package-icon-text'>Sightseeing</span></p>
<p onClick={() => toggleSection(pkg.id, 'meal')}><i class="fa-solid package-icon fa-mug-hot"></i><br /><span className='package-icon-text'>Meals</span></p>
<p onClick={() => toggleSection(pkg.id, 'accomodation')}><i class="fa-solid package-icon fa-star"></i><br /><span className='package-icon-text'>Accomodation</span></p></div>


                      {expand[pkg.id]?.sightseeing && (
  <div className='para-text'>
    <p className='fw-semibold mb-1'>Sightseeing:</p>
    {pkg.sightseeing.split('|').map((item, idx) => (
      <p key={idx} className='mb-1'>• {item.trim()}</p>
    ))}
  </div>
)}

{expand[pkg.id]?.meal && (
  <div className='para-text'>
    <p className='fw-semibold mb-1'>Meals:</p>
    {pkg.meal.split('|').map((mealItem, idx) => (
      <p key={idx} className='mb-1'>• {mealItem.trim()}</p>
    ))}
  </div>
)}

{expand[pkg.id]?.accomodation && (
  <div className='para-text'>
    <p className='fw-semibold mb-1'>Accomodation:</p>
    {pkg.accomodation.split('|').map((item, idx) => (
      <p key={idx} className='mb-1'>• {item.trim()}</p>
    ))}
  </div>
)}

                      {/* {expand[pkg.id]?.accomodation && (
                        <p className='para-text'>Accomodation: {pkg.accomodation}</p>
                      )} */}

{pkg.pac_description != null ? 
<p className='para-text'>Package Details: {pkg.pac_description}</p> : ''
}

<button className='nav-btn bg-black' onClick={() => handleShowRemove(pkg)}>Remove Package</button>

</div>


  </div>
</div>
                ))): (
                  <div className='text-center py-4'>
<img src={EmptyTask} className='img-fluid' alt='gif task' style={{height: '12em'}} />
<p className='fw-semibold fm-dm'>No Packages Added yet.</p></div>
                )}

</div>
{/* row ends */}

          </div>
          </section>

          {showDelete && (
            <>
            <section className='dialog-outer px-4'>
              <div className='dialog-inner py-5 col-lg-6 col-md-8 col-12 mx-auto text-center'>

<p className='fm-dm fw-semibold fs-5'>Want to Remove {selectedPkg.pac_name} Package?</p>

<button className='nav-btn px-3 py-2 bg-black' onClick={() => setShowDelete(false)}>Go Back</button>&nbsp;&nbsp;
<button className='nav-btn px-3 py-2' onClick={() => handleDelete(selectedPkg.id)}>Remove</button>


              </div>
            </section>
            </>
          )}

                  {responseMessage && (
                <div className="response-message d-flex justify-content-between">
                    <p className='my-0 mx-auto'>{responseMessage}</p>
                    <p className='my-0 cursor-pointer' onClick={() => setResponseMessage(false)}> &nbsp;<i class="fa-solid fa-xmark"></i></p>
                </div>)}

          {loading && <Loading setLoading={setLoading} />}
    </>
  )
}

export default AdminDashboard
